import {Component, OnInit, Renderer2} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {Q_TSQM, TSQMResults} from '../../../../model/questionnaires/questionnaire-tsqm';
import {ErrorDialogComponent} from '../../../user-actions/error-dialog/error-dialog.component';
import {QuestionnaireService} from '../../../../services/questionnaire.service';
import {MatDialog} from '@angular/material/dialog';
import {MatRadioButton} from '@angular/material/radio';
import {ActivatedRoute, Router} from '@angular/router';

@Component({
  selector: 'app-questionnaire-tsqm',
  templateUrl: './questionnaire-tsqm.component.html',
  styleUrls: ['./questionnaire-tsqm.component.css']
})
export class QuestionnaireTsqmComponent implements OnInit {

  qForm: FormGroup;
  notFocused = false;
  source = Q_TSQM;
  results = [];
  submitted = false;
  show = false;
  noDisabledButtons = true;
  currentCheckedValue = [null];
  found = false;

  /// toolbar
  back = true;
  destination = '/questionnaires';
  title = 'TSQM';
  user = null;
  uuid = null;
  authorization: boolean;
  doctorID: string;
  patientSSN: string;

  constructor(private questionnaireService: QuestionnaireService,
              private ren: Renderer2,
              public dialog: MatDialog,
              private route: ActivatedRoute,
              private router: Router) { }

  ngOnInit(): void {
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < this.source.length; ++i) {
      this.results.push(null);
    }

    this.user = JSON.parse(localStorage.getItem('user'));
    this.route.params.subscribe(params => {
      this.doctorID = params.doctorID;
      this.patientSSN = params.patientSSN;
      this.uuid = params.uuid;
      this.authorization = this.user.ssn.localeCompare(params.patientSSN) === 0;
      if (params.back.localeCompare('questionnaires') === 0) {
        this.destination = 'questionnaires';
      } else if (params.back.localeCompare('choose-questionnaire') === 0) {
        this.destination = 'choose-questionnaire';
      }
    });
  }

  openDialog(message: string): void {
    const dialogRef = this.dialog.open(ErrorDialogComponent, {
      width: '500px',
      height: '270px',
      data: message
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('Finestra chiusa');
    });
  }

  setAnswer(button: MatRadioButton, answer: string, position: number) {
    if (position === 4) {
      if (answer === 'Si') {
        this.noDisabledButtons = true;
      } else if (answer === 'No (in questo caso, passi alla domanda n.9)') {
        this.noDisabledButtons = false;
        for (let i = position; i < 8; ++i) {
          this.results[i] = null;
        }
      }
    }

    this.results[position - 1] = answer;
    console.log(this.results);
  }

  checkState(el, position: number) {
    setTimeout(() => {
      if (this.currentCheckedValue[position - 1] && this.currentCheckedValue[position - 1] === el.value) {
        el.checked = false;
        this.ren.removeClass(el._elementRef.nativeElement, 'cdk-focused');
        this.ren.removeClass(el._elementRef.nativeElement, 'cdk-program-focused');
        this.currentCheckedValue[position - 1] = null;
        this.results[position - 1] = null;
      } else {
        this.currentCheckedValue[position - 1] = el.value;
      }
    });
  }

  onSubmit() {
    this.submitted = true;
    this.show = true;
    this.found = false;

    let count = 0;

    if (this.results[3] === 'No (in questo caso, passi alla domanda n.9)') {
      for (const r of this.results) {
        if (r === null) {
          count++;
        }
      }

      if (count > 4 || count < 4) {
        this.submitted = false;
        this.show = false;
        this.found = true;
        const msg = 'Non hai finito di completare il questionario!';
        this.openDialog(msg);
      } else {
        this.found = false; // può essere inviato
      }

    } else {
      for (const r of this.results) {
        if (r === null) {
          this.found = true;
          break;
        }
      }
      if (this.found) {
        this.submitted = false;
        this.show = false;
        const msg = 'Non hai finito di completare il questionario!';
        this.openDialog(msg);
      }
    }

    if (!this.found) {
      console.log(this.doctorID + ' ' + this.patientSSN + ' ' + this.results);
      const resultToSend = new TSQMResults(this.doctorID, this.patientSSN, this.results);
      this.questionnaireService.sendForm(resultToSend, 'tsqm', this.uuid);
    }

    }

  goHome() {
    if (this.user === null) {
      this.router.navigateByUrl('/startup');
    } else {
      this.router.navigateByUrl('/landing');
    }
  }
}
